import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BuildFormData, UploadParams, UploadResponseBody } from '@core/interfaces';
import { environment } from 'environments/environment';
import { retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    private http: HttpClient
  ) {}

  public upload(params: UploadParams): Promise<UploadResponseBody> {
    return this.http
      .post<UploadResponseBody>(environment.UPLOAD_URL + '/s3-passthrough-upload', params)
      .pipe(retry(2))
      .toPromise();
  }

  public async uploadWithCredentials({ fields, baseUrl, file }): Promise<void> {
    const formData = this.buildFormData({ fields, file });

    await this.http.post(baseUrl, formData, {
      observe: 'body',
      responseType: 'text',
    }).toPromise();
  }

  private buildFormData({ fields, file }: BuildFormData): FormData {
    const form = new FormData();

    for (const [key, value] of Object.entries(fields)) {
      form.append(key, value);
    }

    form.append('file', file);
    return form;
  }
}
